module.exports = __webpack_public_path__ + "images/mdj/members/mypage/reg_login/reg_login_bnr01-6e1dc7e713fe6a9e4ff6c30ddee5a4b4.jpg";